// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14dah","newExpiryDate":"styles_newExpiryDate__23hkP","footer":"styles_footer__22rw9"};